export default __webpack_public_path__ + "static/media/2.fc9b51af.jpg";